import type { ReactNode } from "react";
import { cx } from "./cx";

export interface FieldProps {
  label: ReactNode;
  /** Muted helper line under the control. Hidden while an error is shown. */
  hint?: ReactNode;
  /** Validation message; shown in place of the hint. */
  error?: ReactNode;
  /** The form control itself — give it `className="field"`. */
  children: ReactNode;
}

/** Matches the POC shape: `<label class="field-label">Label<input class="field" /></label>`. */
export function Field({ label, hint, error, children }: FieldProps) {
  return (
    <label className="field-label">
      {label}
      {children}
      {error != null ? (
        <span className="field-error">{error}</span>
      ) : hint != null ? (
        <span className="field-hint">{hint}</span>
      ) : null}
    </label>
  );
}

export interface FieldGridProps {
  /** POC `.field-grid` is 2 columns; `.field-grid.three` is 3. */
  columns?: 2 | 3;
  className?: string;
  children: ReactNode;
}

export function FieldGrid({ columns = 2, className, children }: FieldGridProps) {
  return <div className={cx("field-grid", columns === 3 && "three", className)}>{children}</div>;
}
